/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NeedCreate } from '../models/NeedCreate';
import type { NeedDetail } from '../models/NeedDetail';
import type { NeedHistory } from '../models/NeedHistory';
import type { NeedNote } from '../models/NeedNote';
import type { NeedStatusHistory } from '../models/NeedStatusHistory';
import type { NeedUpdate } from '../models/NeedUpdate';
import type { PaginatedNeedList } from '../models/PaginatedNeedList';
import type { PaginatedNeedNoteList } from '../models/PaginatedNeedNoteList';
import type { PatchedNeedNote } from '../models/PatchedNeedNote';
import type { PatchedNeedStatusUpdate } from '../models/PatchedNeedStatusUpdate';
import type { PatchedNeedUpdate } from '../models/PatchedNeedUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StaffingService {

    /**
     * @returns PaginatedNeedList
     * @throws ApiError
     */
    public static staffingNeedsList({
        currentReason,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        justifications,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        specialties,
        status,
        statusCategory,
        statusKind,
        urgency,
    }: {
        /**
         * Short code representation of the reason for viewing and reports
         */
        currentReason?: string,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Justifications
         *
         * * `VACANCY` - Vacancy
         * * `LEAVE_COVERAGE` - Leave Coverage
         * * `INCREASED_VOLUME` - Increased Volume
         * * `NEW_STARTUP` - New Startup
         * * `SERVICE_LINE_EXPANSION` - Service Line Expansion
         * * `TEMPORARY_NEED` - Temporary Need
         * * `OTHER` - Other
         */
        justifications?: Array<'INCREASED_VOLUME' | 'LEAVE_COVERAGE' | 'NEW_STARTUP' | 'OTHER' | 'SERVICE_LINE_EXPANSION' | 'TEMPORARY_NEED' | 'VACANCY' | null>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        /**
         * Urgency
         *
         * * `1` - Routine
         * * `2` - Priority
         * * `3` - Urgent
         * * `4` - Critical
         * * `5` - Crisis
         */
        urgency?: Array<'1' | '2' | '3' | '4' | '5' | null>,
    }): CancelablePromise<PaginatedNeedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staffing/needs/',
            query: {
                'current_reason': currentReason,
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'justifications': justifications,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
                'urgency': urgency,
            },
        });
    }

    /**
     * @returns NeedDetail
     * @throws ApiError
     */
    public static staffingNeedsCreate({
        requestBody,
    }: {
        requestBody: NeedCreate,
    }): CancelablePromise<NeedDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staffing/needs/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns NeedNote
     * @throws ApiError
     */
    public static staffingNeedsNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Need Note.
         */
        id: string,
        requestBody: NeedNote,
    }): CancelablePromise<NeedNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/staffing/needs-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns NeedNote
     * @throws ApiError
     */
    public static staffingNeedsNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Need Note.
         */
        id: string,
        requestBody?: PatchedNeedNote,
    }): CancelablePromise<NeedNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staffing/needs-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static staffingNeedsNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Need Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/staffing/needs-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns NeedDetail
     * @throws ApiError
     */
    public static staffingNeedsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
    }): CancelablePromise<NeedDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staffing/needs/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns NeedDetail
     * @throws ApiError
     */
    public static staffingNeedsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        requestBody?: NeedUpdate,
    }): CancelablePromise<NeedDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/staffing/needs/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns NeedUpdate
     * @throws ApiError
     */
    public static staffingNeedsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        requestBody?: PatchedNeedUpdate,
    }): CancelablePromise<NeedUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staffing/needs/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static staffingNeedsDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/staffing/needs/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns NeedHistory
     * @throws ApiError
     */
    public static staffingNeedsChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<NeedHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staffing/needs/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns PaginatedNeedNoteList
     * @returns NeedNote
     * @throws ApiError
     */
    public static staffingNeedsNotesList({
        id,
        currentReason,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        justifications,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        sort,
        specialties,
        status,
        statusCategory,
        statusKind,
        urgency,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        /**
         * Short code representation of the reason for viewing and reports
         */
        currentReason?: string,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Justifications
         *
         * * `VACANCY` - Vacancy
         * * `LEAVE_COVERAGE` - Leave Coverage
         * * `INCREASED_VOLUME` - Increased Volume
         * * `NEW_STARTUP` - New Startup
         * * `SERVICE_LINE_EXPANSION` - Service Line Expansion
         * * `TEMPORARY_NEED` - Temporary Need
         * * `OTHER` - Other
         */
        justifications?: Array<'INCREASED_VOLUME' | 'LEAVE_COVERAGE' | 'NEW_STARTUP' | 'OTHER' | 'SERVICE_LINE_EXPANSION' | 'TEMPORARY_NEED' | 'VACANCY' | null>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        /**
         * Urgency
         *
         * * `1` - Routine
         * * `2` - Priority
         * * `3` - Urgent
         * * `4` - Critical
         * * `5` - Crisis
         */
        urgency?: Array<'1' | '2' | '3' | '4' | '5' | null>,
    }): CancelablePromise<PaginatedNeedNoteList | NeedNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staffing/needs/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_reason': currentReason,
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'justifications': justifications,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
                'urgency': urgency,
            },
        });
    }

    /**
     * @returns PaginatedNeedNoteList
     * @returns NeedNote
     * @throws ApiError
     */
    public static staffingNeedsNotesCreate({
        id,
        requestBody,
        currentReason,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        justifications,
        limit,
        offset,
        ordering,
        queue,
        reason,
        search,
        sort,
        specialties,
        status,
        statusCategory,
        statusKind,
        urgency,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        requestBody: NeedNote,
        /**
         * Short code representation of the reason for viewing and reports
         */
        currentReason?: string,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Justifications
         *
         * * `VACANCY` - Vacancy
         * * `LEAVE_COVERAGE` - Leave Coverage
         * * `INCREASED_VOLUME` - Increased Volume
         * * `NEW_STARTUP` - New Startup
         * * `SERVICE_LINE_EXPANSION` - Service Line Expansion
         * * `TEMPORARY_NEED` - Temporary Need
         * * `OTHER` - Other
         */
        justifications?: Array<'INCREASED_VOLUME' | 'LEAVE_COVERAGE' | 'NEW_STARTUP' | 'OTHER' | 'SERVICE_LINE_EXPANSION' | 'TEMPORARY_NEED' | 'VACANCY' | null>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
        /**
         * Urgency
         *
         * * `1` - Routine
         * * `2` - Priority
         * * `3` - Urgent
         * * `4` - Critical
         * * `5` - Crisis
         */
        urgency?: Array<'1' | '2' | '3' | '4' | '5' | null>,
    }): CancelablePromise<PaginatedNeedNoteList | NeedNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/staffing/needs/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_reason': currentReason,
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'justifications': justifications,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
                'urgency': urgency,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns NeedStatusHistory
     * @throws ApiError
     */
    public static staffingNeedsStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<NeedStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staffing/needs/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns NeedDetail
     * @throws ApiError
     */
    public static staffingNeedsStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Need.
         */
        id: string,
        requestBody?: PatchedNeedStatusUpdate,
    }): CancelablePromise<NeedDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/staffing/needs/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
